import { render, staticRenderFns } from "./SquareCard.vue?vue&type=template&id=bb63d6c6"
import script from "./SquareCard.vue?vue&type=script&lang=js"
export * from "./SquareCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports